<template>
  <div>
    <template v-for="(question, questionIndex) in questions">
      <vvs-select
        v-if="question.type === 'single' && question.singleType === 'select'"
        :name="question.question"
        :label="`${getQuestionNumber({ questionIndex })}${question.question}`"
        :validate="{ required: question.isRequired }"
        :options="question.questionAnswers"
        :key="questionIndex"
        v-model="question.answers[0]"
        :normal-label="normalLabel"
      ></vvs-select>
      <vvs-radio
        v-else-if="
          question.type === 'single' && question.singleType === 'radio'
        "
        :name="question.question"
        :label="`${getQuestionNumber({ questionIndex })}${question.question}`"
        :validate="{ required: question.isRequired }"
        :options="question.questionAnswers"
        :key="questionIndex"
        :big="question.big"
        v-model="question.answers[0]"
        :normal-label="normalLabel"
      ></vvs-radio>
      <vvs-checkbox
        v-else-if="question.type === 'multiple'"
        :name="question.question"
        :label="`${getQuestionNumber({ questionIndex })}${question.question}`"
        :description="getMultipleQuestionLabel({ question })"
        :validate="{ required: question.isRequired }"
        :options="question.questionAnswers"
        :key="questionIndex"
        v-model="question.answers"
        :normal-label="normalLabel"
      ></vvs-checkbox>
      <vvs-textarea
        v-else-if="
          question.type === 'freeText' && question.freeTextType !== 'number'
        "
        :name="question.question"
        :label="`${getQuestionNumber({ questionIndex })}${question.question}`"
        :placeholder="question.question"
        :validate="{
          required: question.isRequired,
          min: question.min || 10,
          max: 1000,
          withoutEmoji: true,
        }"
        :key="questionIndex"
        v-model="question.answers[0]"
        :normal-label="normalLabel"
      ></vvs-textarea>
      <vvs-input
        v-else-if="
          question.type === 'freeText' && question.freeTextType === 'number'
        "
        :name="question.question"
        :label="`${getQuestionNumber({ questionIndex })}${question.question}`"
        :placeholder="question.question"
        :validate="{
          required: question.isRequired,
          numeric: true,
          min_value: 1,
          max_value: 50000,
        }"
        :key="questionIndex"
        maxlength="5"
        v-model="question.answers[0]"
        :normal-label="normalLabel"
      ></vvs-input>
      <vvs-input
        v-else
        :name="question.question"
        :label="`${getQuestionNumber({ questionIndex })}${question.question}`"
        :validate="{
          required: question.isRequired,
          min: question.min || 10,
          max: 1000,
          withoutEmoji: true,
        }"
        :key="questionIndex"
        v-model="question.answers[0]"
        :normal-label="normalLabel"
      ></vvs-input>
    </template>
  </div>
</template>

<script>
export default {
  name: 'VvsQuestions',
  props: {
    questions: {
      type: Array,
      default: () => [],
    },
    formQuestions: {
      type: Array,
      default: () => [],
    },
    staticQuestions: {
      type: Array,
      default: () => [],
    },
    questionStartNumber: {
      type: Number,
      default: 1,
    },
    hideQuestionNumber: {
      type: Boolean,
      default: false,
    },
    normalLabel: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    setQuestions() {
      const formQuestions = [...this.formQuestions];
      let emitQuestions = [];

      if (formQuestions.length === 0) {
        emitQuestions = this.staticQuestions.map(staticQuestion => {
          return {
            ...staticQuestion,
            name: staticQuestion.question,
            answers: [],
          };
        });
      } else {
        emitQuestions = formQuestions.map(question => {
          return {
            ...question,
            ...this.getStaticQuestionByName(question),
          };
        });
      }

      this.$emit('update:questions', emitQuestions);
    },
    getStaticQuestionByName({ name = null }) {
      return (
        this.staticQuestions.find(({ question }) => question === name) || {}
      );
    },
    getMultipleQuestionLabel({ question }) {
      return question.answers.length > 0
        ? `${question.answers.length} adet seçim yaptınız.`
        : '';
    },
    getQuestionNumber({ questionIndex = 0 }) {
      return !this.hideQuestionNumber
        ? `${questionIndex + this.questionStartNumber}. `
        : '';
    },
  },
  watch: {
    formQuestions() {
      this.$nextTick(() => {
        this.setQuestions();
      });
    },
  },
  mounted() {
    this.setQuestions();
  },
};
</script>
